import "./WhatsAppButton.css";

const PHONE = "393930613734";
const MESSAGE = encodeURIComponent(
  "Ciao! Ho visitato il vostro sito e vorrei ricevere informazioni sui vostri servizi di lavorazione in legno."
);
const WA_URL = `https://wa.me/${PHONE}?text=${MESSAGE}`;

export default function WhatsAppButton() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-btn"
      aria-label="Contattaci su WhatsApp"
    >
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" width="52" height="52">
        {/* Outer circle */}
        <circle cx="28" cy="28" r="26" stroke="#c9a84c" strokeWidth="1.6" fill="none" />
        {/* WhatsApp icon centered */}
        <g transform="translate(14, 14)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 2C7.373 2 2 7.373 2 14c0 2.385.68 4.61 1.857 6.492L2 26l3.697-1.354A11.94 11.94 0 0014 26c6.627 0 12-5.373 12-12S20.627 2 14 2zm-3.07 7.5c.22-.01.46.01.66.5.25.6.82 2.02.9 2.17.08.15.13.32.03.52-.1.2-.15.32-.3.49-.15.17-.31.38-.44.51-.15.14-.3.29-.13.57.17.28.75 1.24 1.61 2 1.1.98 2.03 1.28 2.31 1.43.28.14.45.12.62-.07.17-.2.73-.85.92-1.14.2-.3.4-.25.66-.15.27.1 1.7.8 1.99.95.29.14.48.22.56.34.08.13.08.73-.17 1.43-.25.7-1.44 1.34-1.97 1.41-.53.07-1.03.1-3.33-.7-2.8-.98-4.57-3.8-4.71-3.98-.14-.18-1.12-1.5-1.12-2.86 0-1.35.71-2.02.98-2.3.27-.27.57-.34.76-.34z"
            fill="#c9a84c"
          />
        </g>
      </svg>
      <span className="wa-tooltip">Scrivici su WhatsApp</span>
    </a>
  );
}
